import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { lastValueFrom } from 'rxjs';
import { AlmacenService } from 'src/app/services/api/almacen.service';
import Swal from 'sweetalert2';
import { DialogAsignarEquiposFileComponent } from '../../asignar-equipos-file/dialog-asignar-equipos-file/dialog-asignar-equipos-file.component';

@Component({
  selector: 'app-dialog-asignar-tipos',
  templateUrl: './dialog-asignar-tipos.component.html',
  styleUrls: ['./dialog-asignar-tipos.component.css']
})
export class DialogAsignarTiposComponent implements OnInit {

  loading: boolean = true;

  dataSource = new MatTableDataSource();

  file:any

  articulos: any;

  oldData: any;

  displayedColumns: string[] = [
    'nombre',
    'marca',
    'modelo',
    'talla',
    'peso',
    'cantidad',
    'editar'

  ];

  /*   @ViewChild(MatPaginator) paginator!: MatPaginator; */

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  constructor(private almacenService: AlmacenService, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DialogAsignarTiposComponent>, public dialog: MatDialog,) { }

  ngOnInit(): void {
    console.log(this.data,"data")
    this.file = this.data.file
    this.getAllAgrupadoByFileAndProduct()
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.dataSource.data.map((fila: any) => {
        fila.selected = false;
      });
      return;
    } else {
      this.dataSource.data.map((fila: any) => {
        fila.selected = true;
      });
      return;
    }
  }

  isAllSelected() {
    let lst: any[];
    lst = this.dataSource.data.filter((x: any) => x.selected == true);
    const numSelected = lst.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  updateCheck(row: any) {
    console.log(row)
    row.selected = !row.selected;

  }

  getAllAgrupadoByFileAndProduct() {
    this.almacenService.getAllAgrupadoByFileAndProduct(this.data.file.fileId, this.data.file.productId).subscribe((response) => {

      const filterCantPax = response.getAllAgrupadoByFileAndProduct.filter((item: any) => item.agrupadoInfo.nroPersonasPax[this.data.file.cantPax - 1] !== "")

      this.oldData = JSON.parse(JSON.stringify(filterCantPax));
      this.articulos = filterCantPax;

      console.log(this.articulos)

      this.articulos = this.articulos.sort((a: any, b: any) => a.agrupadoInfo?.nombreEquipo.localeCompare(b.agrupadoInfo?.nombreEquipo));

      this.dataSource = new MatTableDataSource(this.articulos);
      if(this.dataSource.data.every((elemento:any) => elemento.selected === false)){
        this.toggleAllRows()
      }

      this.dataSource.paginator = this.paginator
      this.loading = false
    });

  }

  async closeDialog() {

    console.log(this.oldData)
    const changedSelectedDataSource = this.dataSource.data.filter((el: any) => {
      const oldItem = this.oldData.find((oldEl: any) => oldEl.id === el.id);
      // console.log(oldItem)
      return oldItem && oldItem.selected !== el.selected;
    });

    console.log(changedSelectedDataSource)

    await Promise.all(
      changedSelectedDataSource.map(async (el: any) => {
        await lastValueFrom(this.almacenService.updateAgrupadoItinerario(el.id, { selected: el.selected })) 
      })
    )

    Swal.fire({
      position: 'top-end',
      title: 'Los productos fueron asignados correctamente',
      icon: "success",
      showConfirmButton: false,
      timer: 5000
    }
    )
    this.dialogRef.close();



  }

  closeDialogAssing(){
    this.dialogRef.close();
  }

  openDialogAsignarEquipo(item:any,i:number): void {
  
      let dialogConfig=new MatDialogConfig();
      dialogConfig.data={
        item:item,
        file:this.file
      };
      dialogConfig.width="43rem";
      dialogConfig.height="600px";
  
      let dialogRef = this.dialog.open(DialogAsignarEquiposFileComponent, dialogConfig);
  
      dialogRef.afterClosed().subscribe(result => {
        console.log("closed");
        console.log(result);
        // if(result!==null){
        //   Object.assign(this.dataSource.data[i], {...item,totalAssigned:result});
        //   //this.getAllEquipos();
        // }
      });
    }

}
